// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "./I18n.res.js";
import * as React from "react";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";

let make = React.forwardRef((props, ref) => {
  let domRef = Stdlib_Option.map((ref == null) ? undefined : Primitive_option.some(ref), prim => prim);
  let children = props.children;
  if (children !== undefined) {
    let newrecord = {...props};
    return JsxRuntime.jsx("div", (newrecord.tabIndex = -1, newrecord.ref = domRef, newrecord.children = children, newrecord));
  }
  let newrecord$1 = {...props};
  return JsxRuntime.jsx("div", (newrecord$1.tabIndex = -1, newrecord$1.ref = domRef, newrecord$1));
});

function map(data, map$1) {
  return data.map(map$1);
}

function mapWithIndex(data, map) {
  return data.map(map);
}

function mapWithIndexKey(data, map) {
  return data.map((item, index) => map(item, index.toString()));
}

function mapOption(data, map) {
  return Stdlib_Option.mapOr(data, null, map);
}

function _if(condition, then) {
  if (condition) {
    return then();
  } else {
    return null;
  }
}

function either(condition, then, or) {
  if (condition) {
    return then();
  } else {
    return or();
  }
}

let t = I18n.t;

export {
  make,
  map,
  mapWithIndex,
  mapWithIndexKey,
  mapOption,
  _if,
  either,
  t,
}
/* make Not a pure module */
